import * as React from 'react';
import { STATE } from 'app/constants';
import { SpinLoader } from 'app/components';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { routeConstants } from 'app/routes/route-constants';
import * as navigate from 'app/area/shared/navigation';
import { getCodetableId } from 'app/area/shared/codetable/breadcrumbs';
import { CodetableAdministrationState } from './types-store';
import { CodetableSelectorProps } from './types';
import { actionCreators } from './actions';
import { codetableAdministrationTranslation } from './constants';
import { selectors } from './selectors';
import { Outlet } from 'react-router-dom';
import { escapeUrl } from 'app/components/favourite-layout/favourite/common/utils';

type CodetableBaseComponentProps = DefaultContainerProps & CodetableAdministrationState &
  CodetableSelectorProps & typeof actionCreators;

class CodetableBaseComponent extends React.Component<CodetableBaseComponentProps> {
  public static statePath: string = STATE.administrationCodetable;

  public componentDidMount() {
    const { loadMetadata, breadcrumbs } = this.props;
    const currentCodetableId = getCodetableId(breadcrumbs);
    loadMetadata(currentCodetableId);
  }

  public componentDidUpdate(prevProps: CodetableBaseComponentProps) {
    const { metadata: { fetching, data }, access: { fetchingCodes, fetchingCodetables,
      data: { codetables: accessCodetables, codes: accessCodes } = {} }, loadMetadata, breadcrumbs } = this.props;

    const currentCodetableId = getCodetableId(breadcrumbs);
    const prevPropsCodetableId = getCodetableId(prevProps.breadcrumbs);
    const currentCodeId: number = this.props.params && this.props.params.codeId && parseInt(this.props.params.codeId, 10);

    if (currentCodetableId && !fetchingCodetables && !accessCodetables) {
      this.props.loadCodetablesAccess(currentCodetableId);
    }

    if (isDefinedIncludingZero(currentCodeId) && !fetchingCodetables
      && !isDefinedIncludingZero(fetchingCodes) && !!accessCodetables && !accessCodes) {
      this.props.loadCodesAccess(this.props);
    }

    if (currentCodetableId !== prevPropsCodetableId) {
      loadMetadata(currentCodetableId);
      return;
    }

    if (!currentCodetableId && fetching === undefined && data) {
      navigate.replace(escapeUrl(routeConstants.codetableAdministrationFor(breadcrumbs)));
    }
  }

  public componentWillUnmount() {
    this.props.clearCodetablesAccess();
  }

  public render() {

    const { metadata: { fetching: fetchingMetadata, data }, access: { fetchingCodetables, fetchingCodes }, breadcrumbs } = this.props;
    const currentCodetableId = getCodetableId(breadcrumbs);
    const fetching = fetchingMetadata !== undefined && fetchingCodetables !== undefined && fetchingCodes !== undefined;

    if (fetching || isDefinedIncludingZero(fetchingCodetables)
      || !data || !data.codetable || data.codetable.id !== currentCodetableId) {
      return <SpinLoader />;
    }

    return <Outlet />;
  }
}

const container = containerFactory(CodetableBaseComponent, actionCreators, selectors, codetableAdministrationTranslation);

export { container as CodetableBase };
